<div class="form-wrapper" style="position: relative;" [class.dark-overlay]="submitting">
  @if (submitting) {
    <div class="loading-indicator">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }
  <div class="row" [formGroup]="form">
    <div class="col-lg-3 col-sm-12 application-gutter" [class.hidden]="showPrintView">
      <h3>Witness Application</h3>
      <section class="application-nav sticky-top">
        <div>
          <mat-vertical-stepper (selectionChange)="gotoPage($event)" #stepper [class.disabled-stepper]="submitting">
            <ng-template matStepperIcon="edit">
              <i class="fa fa-check"></i>
            </ng-template>
            <ng-template matStepperIcon="error">
              <i class="fa fa-times"></i>
            </ng-template>
            <ng-template matStepperIcon="number">
            </ng-template>
            <mat-step label="Overview" [hasError]="!isMyControlValid(form.get('introduction'))"></mat-step>
            <mat-step label="Personal Information & Addresses" [hasError]="!isMyControlValid(form.get('personalInformation'))"></mat-step>
            <mat-step label="Victim Information" [hasError]="!isMyControlValid(form.get('victimInformation'))"></mat-step>
            <mat-step label="Crime Information" [hasError]="!isMyControlValid(form.get('crimeInformation'))"></mat-step>
            <mat-step label="Medical Information" [hasError]="!isMyControlValid(form.get('medicalInformation'))"></mat-step>
            <mat-step label="Expense & Benefits" [hasError]="!isMyControlValid(form.get('expenseInformation'))"></mat-step>
            <mat-step label="Application on Behalf of Witness" [hasError]="!isMyControlValid(form.get('representativeInformation'))"></mat-step>
            <mat-step label="Declaration" [hasError]="!isMyControlValid(form.get('declarationInformation'))"></mat-step>
            <mat-step label="Authorization" [hasError]="!isMyControlValid(form.get('authorizationInformation'))"></mat-step>
            <mat-step label="Review & Submit"></mat-step>
          </mat-vertical-stepper>

          <app-stepper-nav-tip></app-stepper-nav-tip>

          <div class="tooltip-info-container">
            When you see <app-tool-tip></app-tool-tip>, hover over this icon for more information
          </div>

          <div class="submit-container learn-benefits">
            <div class="submit-content">
              <h2>Want to learn more about your Benefits?</h2>
              <p>Click below to open a new window and view the full summary of benefits.</p>
              <p>You will not lose your progress on this application.</p>
              <p><button class="btn btn-secondary btn-wrappable" (click)="showSummaryOfBenefits()">View Summary of Benefits</button></p>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="col-lg-7 col-sm-12">
      <form [formGroup]="form">

        @if (isIE) {
          <div class="alert alert-danger warning-message">
            <p>It looks like you are using an unsupported browser.</p>
            <p>For best results, we recommend you use Chrome, Firefox, Edge, or Safari.</p>
          </div>
        }

        @if (canSaveDraft) {
          <div style="display: flex; justify-content: flex-end; align-items: center; gap: 1rem; margin: 1rem 0;">
            <div class="save-info">
              @if (autoSaveCountdown <= 30 && autoSaveCountdown > 0) {
                <i>Saving in {{ autoSaveCountdown }} {{ autoSaveCountdown === 1 ? "second" : "seconds" }}...</i>
              }
              @if (lastSavedAt && (autoSaveCountdown === 0 || autoSaveCountdown > 30)) {
                <i>Saved at {{ lastSavedAt | date: "mediumTime" }}</i>
              }
            </div>
            <button (click)="saveDraft();" class="btn btn-secondary save-draft-btn" [disabled]="saving || !formChanged">
              @if (saving) { Saving&hellip; } @else { <i class="fas fa-save" style="margin-right: 6px;"></i>Save Draft }
            </button>
          </div>
        }

        @if (this.currentFormStep == 0 || showPrintView) {
          <app-introduction [formGroup]="form" [formType]="FORM_TYPE" formGroupName="introduction"></app-introduction>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 1 || showPrintView) {
          <app-personal-information [formGroup]="form" [formType]="FORM_TYPE" formGroupName="personalInformation"></app-personal-information>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 2 || showPrintView) {
          <app-victim-information [formGroup]="form" [formType]="FORM_TYPE" formGroupName="victimInformation"></app-victim-information>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 3 || showPrintView) {
          <app-crime-information [formGroup]="form" [formType]="FORM_TYPE" formGroupName="crimeInformation"></app-crime-information>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 4 || showPrintView) {
          <app-medical-information [formGroup]="form" [formType]="FORM_TYPE" formGroupName="medicalInformation"></app-medical-information>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 5 || showPrintView) {
          <app-expense-information [formGroup]="form" [formType]="FORM_TYPE" formGroupName="expenseInformation"></app-expense-information>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 6 || showPrintView) {
          <app-representative-information [formGroup]="form" [formType]="FORM_TYPE" formGroupName="representativeInformation"></app-representative-information>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 7 || showPrintView) {
          <app-declaration-information [formGroup]="form" [formType]="FORM_TYPE" formGroupName="declarationInformation"></app-declaration-information>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 8 || showPrintView) {
          <app-authorization-information [formGroup]="form" [formType]="FORM_TYPE" formGroupName="authorizationInformation"></app-authorization-information>
        }

        <div class="pagebreak"> </div>
        @if (this.currentFormStep == 9 || showPrintView) {
          <app-application-review [formGroup]="form" [formType]="FORM_TYPE" [parentStepper]="stepper"></app-application-review>
        }

        @if (showValidationMessage) {
          <div class="error-summary">
            <i class="fas fa-exclamation-triangle" style="margin-right: 10px;"></i>
            <span>There are errors with some fields on this page. Please scroll up to review and fix the errors (marked in red) before continuing.</span>
          </div>
        }

        @if (!showPrintView) {
          <section class="button-container">
            <a (click)="verifyCancellation()" class="cancel-link"><i class="fas fa-trash-alt" style="margin-right: 10px;"></i>Cancel Application</a>
            <span class="right-buttons">              
              @if (stepper.selectedIndex < 9) {
                <button (click)="gotoNextStep(stepper);" class="btn btn-primary">CONTINUE <i class="fas fa-chevron-right"></i></button>
              }
              <div class="left-buttons download-grid" [class.disabled-wrapper]="submitting">
                @if (stepper.selectedIndex == 9) {
                  <button (click)="printApplication();" class="btn btn-primary print-button" [class.is-disabled]="submitting">PRINT PDF</button>
                }
                @if (stepper.selectedIndex == 9) {
                  <button (click)="downloadPDF();" class="btn btn-primary print-button" [class.is-disabled]="submitting">DOWNLOAD PDF</button>
                }
              </div>
              <div class="submit-grid" [class.disabled-wrapper]="submitting">
                @if (stepper.selectedIndex == 9) {
                  <button (click)="markAsTouched(); submitApplication();" class="btn btn-primary" [class.is-disabled]="submitting">SUBMIT APPLICATION <i class="fas fa-chevron-right"></i></button>
                }
              </div>
            </span>
          </section>
        }
      </form>
    </div>
  </div>
</div>